import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { PlayerCadenceResult } from '../types';
import { base64ToObject } from '../utils';
import { Typography, Stack } from '@mui/material';
import PlayerCadenceWeekCard from '../components/PlayerCadenceWeekCard';

export const PlayersCadence = () => {
  const { resultCode } = useParams<{ resultCode: string }>();
  const [result, setResult] = useState<PlayerCadenceResult | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    try {
      const result = base64ToObject<PlayerCadenceResult>(resultCode);
      setResult(result);
    } catch (error: any) {
      setError(error);
    }
  }, [resultCode]);

  if (error || !result) {
    return <Typography>Invalid code</Typography>;
  }

  return (
    <Stack direction="column">
      <Typography variant="h6" sx={{ mb: 4, mt: 2, textAlign: 'center' }}>
        Players cadence in the next {result.dates.length} weeks
      </Typography>
      <Stack
        direction={{
          xs: 'column',
          sm: 'column',
          md: 'column',
          lg: 'row',
        }}
        sx={{
          justifyContent: 'space-evenly',
        }}
      >
        {result.dates.map((date, index) => (
          <PlayerCadenceWeekCard
            date={date}
            players={result.players
              .filter((player) => player.cadence[index])
              .sort((a, b) => b.appearances - a.appearances)}
          />
        ))}
      </Stack>
    </Stack>
  );
};
